import { render, staticRenderFns } from "./TableExperiment.vue?vue&type=template&id=ef60f7f4&scoped=true"
import script from "./TableExperiment.vue?vue&type=script&lang=js"
export * from "./TableExperiment.vue?vue&type=script&lang=js"
import style0 from "./TableExperiment.vue?vue&type=style&index=0&id=ef60f7f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef60f7f4",
  null
  
)

export default component.exports